//#region src/v2/features/localization/translations.ts
/** English fallback for API Client UI strings. */
var en = {
	serverVariablesSelect: { selected: "Selected:" },
	serverVariablesTextbox: { value: "value" },
	sidebarListElementForm: { cancel: "Cancel" },
	requestBlock: {
		authentication: "Authentication",
		variables: "Variables",
		cookies: "Cookies",
		headers: "Headers",
		queryParameters: "Query Parameters",
		queryString: "Query String",
		queryStringDescription: "This parameter supplies the entire query string, so additional named parameters cannot be added. Existing named parameters are sent after it; duplicate keys are preserved.",
		requestBody: "Request Body",
		requestName: "Request Name",
		label: "Request: {name}"
	},
	responseBlock: {
		response: "Response",
		requestHeaders: "Request Headers",
		responseHeaders: "Response Headers",
		body: "Body"
	},
	codeInput: {
		required: "Required",
		exitHint: "Press {escape} then {tab} to exit"
	},
	codeInputLite: { required: "Required" },
	dataTableInput: {
		clearValue: "Clear Value",
		showPassword: "Show Password",
		hidePassword: "Hide Password"
	},
	dataTableInputSelect: {
		value: "Value",
		addValue: "Add value"
	},
	confirmationForm: {
		cancel: "Cancel",
		save: "Save"
	},
	collapsibleSection: {
		collapsed: "(Collapsed)",
		item: "Item",
		items: "Items"
	},
	modalClientContainer: { label: "API Client" },
	serverDropdown: {
		server: "Server:",
		addServer: "Add Server",
		updateServers: "Update Servers",
		unknownServer: "Unknown server"
	},
	sidebar: { search: "Search" },
	sidebarMenu: { settings: "Settings" },
	sidebarToggle: {
		hide: "Hide sidebar",
		show: "Show sidebar"
	},
	environmentsList: { addEnvironment: "Add Environment" },
	modal: { noDocumentSelected: "No document selected" },
	operation: { selectAnOperationToViewDetails: "Select an operation to view details" },
	header: {
		operationSettings: "Operation settings",
		closeClient: "Close Client"
	},
	openApiClientButton: { openAPIClient: "Open API Client" },
	requestBody: {
		noBody: "No Body",
		delete: "Delete",
		selectFile: "Select File",
		multipartForm: "Multipart Form",
		formUrlEncoded: "Form URL Encoded",
		binaryFile: "Binary File",
		other: "Other",
		none: "None"
	},
	requestBodyStructured: { body: "Body" },
	requestBodyViewToggle: {
		form: "Form",
		raw: "Raw",
		fixBody: "Fix the body to switch to the form view"
	},
	requestCodeSnippet: {
		unavailable: "No code sample available for this example.",
		codeSnippet: "Code Snippet"
	},
	requestTable: {
		enabled: "Enabled",
		key: "Key",
		value: "Value"
	},
	requestTableRow: {
		key: "Key",
		value: "Value",
		delete: "Delete",
		selectFile: "Select File",
		globalCookieHint: "Global cookies are shared across the whole workspace. Click to navigate.",
		readOnlyHint: "This is a readonly property and you can not modify it! If you want to change it you have to override it or disable it using the checkbox",
		include: "Include {name} in request",
		keyLabel: "{name} Key",
		valueLabel: "{name} Value",
		deleteRow: "Delete {name}",
		row: "row"
	},
	requestTableTooltip: {
		min: "min:",
		max: "max:",
		default: "default:",
		invalid: "Input is invalid",
		moreInformation: "More Information"
	},
	headers: {
		headerKey: "Header Key",
		headerValue: "Header Value",
		noHeaders: "No headers"
	},
	responseBody: { binaryFile: "Binary file" },
	responseBodyPreview: { previewUnavailable: "Preview unavailable" },
	responseBodyStreaming: {
		body: "Body",
		listening: "Listening…",
		cancel: "Cancel"
	},
	responseBodyToggle: {
		preview: "Preview",
		raw: "Raw"
	},
	responseBodyVirtual: {
		body: "Body",
		largeBodyHint: "This response body is massive! Syntax highlighting won't work here."
	},
	responseCookies: {
		cookies: "Cookies",
		cookieName: "Cookie Name",
		cookieValue: "Cookie Value",
		noCookies: "No cookies"
	},
	responseEmpty: {
		roadmap: "Roadmap",
		poweredByScalarcom: "Powered By Scalar.com",
		getStarted: "Get Started",
		newRequest: "New Request",
		sendRequest: "Send Request",
		version: "Scalar App V{version} Beta"
	},
	responseLoadingOverlay: { cancel: "Cancel" },
	addressBar: {
		path: "Path",
		copyUrl: "Copy URL",
		send: "Send",
		sendRequest: "Send {method} request to {url}",
		duplicateRequest: "A {method} request to {path} already exists in this document",
		urlPlaceholder: "Enter a URL",
		webhookUrlPlaceholder: "Enter the full webhook URL, e.g. https://example.com/hook"
	},
	addressBarHistory: { requestHistory: "Request History" },
	environmentSelector: {
		noEnvironment: "No Environment",
		notAvailableInThisContext: "Not available in this context",
		environmentHint: "Environments let you manage variables like API keys and base URLs across different contexts.",
		add: "Add Environment",
		select: "Select Environment",
		unavailable: "{name} (Unavailable)",
		current: "Current environment: {name}"
	},
	deleteRequestAuthModal: {
		deleteSecurityScheme: "Delete Security Scheme",
		cancel: "Cancel",
		delete: "Delete",
		confirmation: "This cannot be undone. You're about to delete the {name} security scheme from the collection."
	},
	oauth2: {
		deviceAuthorizationUrl: "Device Authorization URL",
		deviceVerificationPrompt: "Open the verification page and enter this code:",
		waitingForAuthorization: "Waiting for authorization…",
		cancelDeviceAuthorization: "Cancel",
		accessToken: "Access Token",
		refreshUrl: "Refresh URL",
		refresh: "Refresh",
		authUrl: "Auth URL",
		tokenUrl: "Token URL",
		redirectUrl: "Redirect URL",
		username: "Username",
		password: "Password",
		clientID: "Client ID",
		clientSecret: "Client Secret",
		usePKCE: "Use PKCE",
		credentialsLocation: "Credentials Location",
		authorize: "Authorize",
		clear: "Clear",
		failedToauthorize: "Failed to authorize",
		failedToRefreshToken: "Failed to refresh token",
		optionalRedirectUrl: "Optional redirect URL"
	},
	oauthScopesAddModal: {
		name: "Name:",
		description: "Description:",
		readUserData: "Read user data",
		edit: "Edit Scope",
		add: "Add Scope",
		save: "Save",
		required: "Scope name is required.",
		duplicate: "A scope named \"{name}\" already exists."
	},
	oauthScopesInput: {
		noScopesDefined: "No Scopes Defined",
		addScope: "Add Scope",
		deselectAll: "Deselect All",
		selectAll: "Select All",
		selectedScopes: "Scopes Selected {count} / {total}",
		editScope: "Edit {name}",
		deleteScope: "Delete {name}",
		selectScope: "Select {name} scope"
	},
	openIdConnect: {
		discoveryUrl: "Discovery URL",
		fetchConfiguration: "Fetch Configuration",
		failedToFetchConfiguration: "Failed to fetch OpenID Connect configuration"
	},
	requestAuthDataTable: { noauthenticationSelected: "No authentication selected" },
	requestAuthTab: {
		token: "Token",
		bearerToken: "Bearer Token",
		getAToken: "Get a token",
		refresh: "Refresh",
		username: "Username",
		password: "Password",
		name: "Name",
		value: "Value",
		cancel: "Cancel",
		authorize: "Authorize",
		unsupportedCredentials: "Credentials for this AsyncAPI security scheme are not sent by the browser client.",
		authorizeVia: "Authorize via {name}",
		unsupportedType: "The {type} security scheme type is not supported yet.",
		missingType: "The security scheme is missing a type, please double check your {type} document or Authentication Configuration",
		failedToauthorize: "Failed to authorize",
		failedToRefresh: "Failed to refresh",
		configure: "Configure {name}",
		mutualTlsHint: "Mutual TLS authenticates with a client certificate presented during the TLS handshake, so there is nothing to enter here."
	},
	commandActionForm: { continue: "Continue" },
	environment: {
		thisIsTheActiveEnvironment: "This is the active environment",
		active: "Active",
		editEnvironment: "Edit Environment",
		deleteEnvironment: "Delete Environment"
	},
	environmentCreateModal: {
		environmentName: "Environment name",
		thisEnvironmentNameIsAlreadyInUse: "This environment name is already in use.",
		update: "Update Environment",
		add: "Add Environment"
	},
	environmentDeleteModal: {
		cancel: "Cancel",
		deleteEnvironment: "Delete Environment",
		deleteConfirmation: "Are you sure you want to delete this environment? This action cannot be undone.",
		title: "Delete {name}"
	},
	environmentVariablesDropdown: {
		variableSuggestions: "Variable suggestions",
		addVariable: "Add Variable"
	},
	environmentVariablesTable: {
		name: "Name",
		value: "Value",
		actions: "Actions",
		environmentVariableName: "Environment Variable Name",
		environmentVariableValue: "Environment Variable Value"
	},
	documentSearchModal: {
		documentSearch: "Document Search",
		documentSearchResults: "Document Search Results",
		navigate: "↑↓ Navigate",
		select: "⏎ Select",
		keyboardInstructions: "Press up arrow / down arrow to navigate, enter to select, type to filter results"
	},
	searchResult: {
		httpMethod: "HTTP Method:",
		path: "Path:",
		description: "Description:",
		heading: "Heading",
		operation: "Operation",
		tag: "Tag"
	},
	sectionFilter: {
		all: "All",
		auth: "Auth",
		variables: "Variables",
		cookies: "Cookies",
		headers: "Headers",
		query: "Query",
		body: "Body"
	},
	requestParams: {
		clearAll: "Clear All {title}",
		clear: "Clear",
		clearOptionalParameters: "Clear optional parameters"
	},
	responseBodyDownload: {
		download: "Download Response Body",
		label: "Download",
		body: "Response Body"
	},
	responseMetaInformation: {
		duration: "Response Information, Duration:",
		size: ", Size:",
		status: ", Status:"
	},
	authSelector: {
		selectedType: "Selected Auth Type: {type}",
		multipleTypes: "Multiple Auth Types Selected",
		selectType: "Select Auth Type",
		optional: "Optional",
		required: "Required",
		deleteScheme: "Delete {name}",
		requiredGroup: "Required authentication",
		availableGroup: "Available authentication",
		addGroup: "Add new authentication"
	},
	operationBlock: {
		webhookUrlRequired: "Webhook URL required. Enter a destination first.",
		pathParametersRequired: "Path parameters must have values.",
		forbiddenMethod: "The Fetch API cannot send {method} requests."
	},
	dataTableCheckbox: { toggle: "Toggle" },
	pillTooltipHost: {
		computedAtExecution: "Computed at request execution",
		noValue: "No value"
	},
	authOptions: {
		oauth2DeviceAuthorization: "OAuth2 Device Authorization",
		apiKeyCookie: "API Key in Cookies",
		apiKeyHeader: "API Key in Headers",
		apiKeyQuery: "API Key in Query Params",
		httpBasic: "HTTP Basic",
		httpBearer: "HTTP Bearer",
		oauth2Implicit: "Oauth2 Implicit Flow",
		oauth2Password: "Oauth2 Password Flow",
		oauth2ClientCredentials: "Oauth2 Client Credentials",
		oauth2AuthorizationFlow: "Oauth2 Authorization Code"
	},
	deleteSidebarListElement: { delete: "Delete {name}" },
	deleteModal: { delete: "Delete {name}" }
};
//#endregion
export { en };

//# sourceMappingURL=translations.js.map